import { Crosshair } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerGoalsSpec: ModuleSpec = {
  id: "customer-goals",
  icon: Crosshair,
  i18n: {
    namespace: "modules",
    titleKey: "customer-goals.title",
    descriptionKey: "customer-goals.description",
  },
  nav: {
    path: "/customers/goals",
    group: "observe",
    order: 70,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Define and track conversion goals",
  },
};
